"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PropertyCondition_1 = require("./PropertyCondition");
class MapCondition extends PropertyCondition_1.PropertyCondition {
    constructor(property, itemCondition) {
        super(property);
        this.itemCondition = itemCondition;
    }
    setOptions(options) {
        super.setOptions(options);
        this.itemCondition.setOptions(options);
    }
    isFulfilled(value) {
        const superResult = super.checkProperty(value);
        if (superResult.isFinal) {
            return superResult.result;
        }
        const isMap = typeof (value[this.property]) === "object" && !(value[this.property] instanceof Array);
        if (!isMap) {
            return this.createUnfulfilledResult(value, "is not a map");
        }
        const result = { fulfilled: true, reasons: [] };
        Object.entries(value[this.property]).forEach(([key, item]) => {
            const itemResult = this.itemCondition.isFulfilled(item);
            if (!itemResult.fulfilled) {
                result.fulfilled = false;
                result.reasons = result.reasons.concat(this.prefixPaths(key, itemResult.reasons));
            }
        });
        return result.fulfilled ? { fulfilled: true } : result;
    }
    prefixPaths(key, reasons) {
        return reasons.map((reason) => {
            if (reason.path.length === 0) {
                reason.path = `${this.property}.${key}`;
            }
            else {
                reason.path = `${this.property}.${key}.${reason.path}`;
            }
            return reason;
        });
    }
}
exports.MapCondition = MapCondition;
//# sourceMappingURL=MapCondition.js.map